import { useState } from "react";
import { Checkbox } from "../../../../components/Checkbox";
import { Column } from "../../../../components/Column";
import { Row } from "../../../../components/Row";
import { Input } from "../../../../components/Input";
import { Button, ChevronIcon, Content, Divider, Field, Label, Toggle } from "../../../../components/Forms";
import { mapInitialSearch } from "../../../../hooks/useDecisions";
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from "react-icons/ai";
import { Accordion } from "../../../../components/Accordion";
import {indices} from "../../../../mocks/indices"
import { TreeSelect } from "../../../../components/TreeSelect";
import useAnalyticsEventTracker from '../../../../hooks/useAnalyticsEventTracker';

interface paramsProps {
  submit(value: any, page?: number): void;
  initialSearch?: string
}

export function Form({ submit, initialSearch = "" }: paramsProps) {
  const gaEventTracker = useAnalyticsEventTracker('Decisions Form');

  const [initialTypePublicacao, setInitialTypePublicacao] = useState('text');
  const [finalTypePublicacao, setFinalTypePublicacao] = useState('text');
  const [initialTypeJulgamento, setInitialTypeJulgamento] = useState('text');
  const [finalTypeJulgamento, setFinalTypeJulgamento] = useState('text');

  const [mainSearch, setMainSearch] = useState('');
  const [initialDatePublicacao, setInitialDatePublicacao] = useState('');
  const [finalDatePublicacao, setFinalDatePublicacao] = useState('');
  
  const [numero, setNumero] = useState('');
  const [orgao, setOrgao] = useState('');
  const [relatoria, setRelatoria] = useState('');
  const [initialDateJulgamento, setInitialDateJulgamento] = useState('');
  const [finalDateJulgamento, setFinalDateJulgamento] = useState('');
  const [index, setIndex] = useState('');

  const initialSelect = mapInitialSearch(initialSearch);
  const [selectList, setSelectList] = useState<string[]>((initialSelect)? [initialSelect] : []);

  const [isFormOpen, setIsFormOpen] = useState(false);

  function selectType(value: boolean, label: string) {
    if(value) {
      setSelectList([...selectList, label])
    } else {
      setSelectList(selectList.filter(item => item !== label));
    }
    
  }
  
  async function onSubmit(e: any) {
    e.preventDefault();

    const search_temp = {
      search_text: mainSearch,
      initialDateJulgamento,
      finalDateJulgamento,
      initialDatePublicacao,
      finalDatePublicacao,
      numero,
      orgao,
      relatoria,
      indice: index,
      tribunal: selectList
    }
    gaEventTracker('submit', JSON.stringify(search_temp))

    await submit(search_temp, 1);
  }
  return (
    <>
      <Toggle onClick={() => setIsFormOpen(!isFormOpen)} customWidth="calc(100% - 54px)" margin="auto">
        <span>Pesquisar</span>
        <AiOutlinePlusSquare display={!isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
        <AiOutlineMinusSquare display={isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
      </Toggle>
      <Accordion isOpen={isFormOpen} hasBorder={false} margin="0" customWidth="calc(46% - 12px)">
        <Content
          onSubmit={onSubmit}
        >
          <Row>
            <Column>
              <Label>Busca Livre</Label>
              <Input
                type="text"
                placeholder="Pesquisar"
                marginBottom="16px"
                value={mainSearch}
                onChange={(value) => setMainSearch(value)}
              />
            </Column>
            <Column>
              <Label>Número</Label>
              <Input
                type="text"
                placeholder=""
                marginBottom="16px"
                value={numero}
                onChange={(value) => setNumero(value)}
              />
            </Column>
          </Row>
          <Row>
            <Column>
              <Label>Órgão</Label>
              <Input
                type="text"
                placeholder=""
                marginBottom="16px"
                value={orgao}
                onChange={(value) => setOrgao(value)}
              />
            </Column>
            <Column>
              <Label>Relatoria</Label>
              <Input
                type="text"
                placeholder=""
                marginBottom="16px"
                value={relatoria}
                onChange={(value) => setRelatoria(value)}
              />
            </Column>
          </Row>
          <Label>Data de publicação</Label>
          <Row breakOnMobile={false}>
            <Field marginBottom="6px">
              <Input
                type={initialTypePublicacao}
                placeholder=""
                onFocus={() => setInitialTypePublicacao('date')}
                value={initialDatePublicacao}
                onChange={(value) => setInitialDatePublicacao(value)}
              />
            </Field>
            <Divider>A</Divider>
            <Field marginBottom="6px">
              <Input
                type={finalTypePublicacao}
                placeholder=""
                onFocus={() => setFinalTypePublicacao('date')}
                value={finalDatePublicacao}
                onChange={(value) => setFinalDatePublicacao(value)}
              />
            </Field>
          </Row>
          <Label>Data de julgamento</Label>
          <Row breakOnMobile={false}>
            <Field marginBottom="6px">
              <Input
                type={initialTypeJulgamento}
                placeholder=""
                onFocus={() => setInitialTypeJulgamento('date')}
                value={initialDateJulgamento}
                onChange={(value) => setInitialDateJulgamento(value)}
              />
            </Field>
            <Divider>A</Divider>
            <Field marginBottom="6px">
              <Input
                type={finalTypeJulgamento}
                placeholder=""
                onFocus={() => setFinalTypeJulgamento('date')}
                value={finalDateJulgamento}
                onChange={(value) => setFinalDateJulgamento(value)}
              />
            </Field>
          </Row>
          <Label>Índice</Label>
          <Field marginBottom="16px">
            <TreeSelect 
              data={indices} 
              marginBottom="0px"
              dropdownMaxHeight="600px"
              value={index}
              onChange={(value: any) => setIndex(value)}
            />
            <ChevronIcon size={24} />
          </Field>
          <Label>Tribunal</Label>
          <Row>
            <Column>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="STF" />
              </Field>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="STJ" />
              </Field>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="TSE" />
              </Field>
            </Column>
            <Column>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="TST" />
              </Field>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="TRF" />
              </Field>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="Tribunais de Justiça" />
              </Field>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="Súmulas" />
              </Field>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="Enunciados do CJF" />
              </Field>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="Decisões do CNDA" />
              </Field>
              <Field marginBottom="10px">
                <Checkbox onChange={selectType} forceSelfSelect={true} initialSearchedList={[initialSelect]} label="Outros" />
              </Field>
            </Column>
          </Row>
          <Button>Pesquisar</Button>
        </Content>
      </Accordion>
    </>
  );
}